import { createFileRoute } from "@tanstack/react-router";
import ThankYouQuote from "@/pages/ThankYouQuote";

export const Route = createFileRoute("/thank-you/quote")({
  component: ThankYouQuote,
});
